import {
  white,
  black,
  lightBlue900,
  greyA100,
  grey100,
  blue300,
  green100,
  orange500,
  blue100,
  blue900,
} from './colors';

const allegiantBlue = '#01579b';

var colors = {};

colors.region = {
  header: lightBlue900,
  footer: white,
  content: white,
};

colors.button = {
  primary: allegiantBlue,
  primaryActive: '#1976d2',
  secondary: '#bbdefb',
  secondaryText: allegiantBlue,
  secondaryBorder: allegiantBlue,
  secondaryActive: '#e3f2fd',
  alternate: allegiantBlue,
  alternateBorder: allegiantBlue,
  alternateActive: '#1871ca',
  contrastBorder: white,
  disabled: '#e0e0e0',
  disabledText: '#999',
};

colors.tooltip = {
  errorBackground: '#faeee5',
  infoBackground: blue100,
  errorBorder: '#dd2c00',
  infoBorder: blue900,
};

colors.expando = {
  labelText: '#1871ca',
  labelTextActive: '#13589c',
  background: greyA100,
  collapsedStroke: grey100,
  expandedStroke: blue300,
  secondaryBackground: green100,
};

colors.modal = {
  title: allegiantBlue,
  border: orange500,
  wrapperBackground: white,
  color: black,
};

export default colors;
